// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--3MuUc","heading":"e2ff468f85--heading--2IQO7","villages_count":"e2ff468f85--villages_count--3phaH"};